'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelidate/lib/validators/required.js
// module id = ./node_modules/vuelidate/lib/validators/required.js
// module chunks = 0